import { get, post } from "helpers/api_helper";
import { getUserToken } from "helpers/authHelper";
import { encryptDataToArray } from "helpers/EncDec";
import { getDeviceInfo } from "helpers/utils";

export async function FetchAllOrganizations(reqBody) {
  reqBody = encryptDataToArray(reqBody);

  return await post(
    "/admin/organization/list",
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
      },
    }
  );
}

export async function CreateNewOrganization(reqBody) {
  let device_info = await getDeviceInfo(navigator);
  reqBody = {
    ...(reqBody || {}),
    device_info: device_info,
  };

  reqBody = encryptDataToArray(reqBody);

  return await post(
    "/admin/organization/create",
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
      },
    }
  );
}

export async function UpdateOrganizationDetails(orgId, reqBody) {
  let device_info = await getDeviceInfo(navigator);
  reqBody = {
    ...(reqBody || {}),
    device_info: device_info,
  };

  reqBody = encryptDataToArray(reqBody);

  return await post(
    `/admin/organization/update/${orgId}`,
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
      },
    }
  );
}

export async function DeleteOrganization(orgId) {
  let device_info = await getDeviceInfo(navigator);
  let reqBody = {
    device_info: device_info,
  };

  reqBody = encryptDataToArray(reqBody);

  return await post(
    `/admin/organization/delete/${orgId}`,
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
      },
    }
  );
}

export async function FetchOrganizationById(orgId) {
  return await get(`/admin/organization/fetch/${orgId}`, {
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}
